module.exports = __webpack_public_path__ + "static/media/black-loader.a4027b6f.svg";